import React, { Component } from 'react';

// Post-login module picker for mobile/tablet Load-Management users (viewport
// < 768px at login time - see Loginform.js getUserDashboardUrl). Ported from
// test.html's screenLanding. The header is rendered once by MobileTruckLoadShell -
// this only renders the content that goes into its content area.
export default class MobileLanding extends Component {
    goLoadManagement = () => {
        // Real desktop grid - leaves the mobile flow entirely. This flag tells
        // app.jsx's own mobile/tablet auto-redirect (which otherwise sends a
        // mobile/tablet Load Management user straight back to /lm-mobile/landing
        // on every desktop page mount) to stand down for this deliberate choice -
        // without it, this button would just bounce straight back to here.
        // MobileTruckLoadShell clears it again on mount, so returning to the
        // mobile flow re-arms the guard for next time.
        sessionStorage.setItem('mtl_desktop_override', '1');
        this.props.history.push('/lmloadmanager');
    };

    goTruckAutomation = () => {
        this.props.history.push('/lm-mobile/dashboard');
    };

    render() {
        return (
            <div className="mtl-screen-scroll">
                <div className="mtl-landing-greeting">
                    <h2>Welcome back</h2>
                    <p>Select a module to continue</p>
                </div>
                <div className="mtl-landing-cards">
                    <div className="mtl-landing-card" onClick={this.goLoadManagement}>
                        <div className="mtl-landing-card-icon mtl-green">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"></path>
                                <rect x="9" y="3" width="6" height="4" rx="1"></rect>
                                <line x1="8" y1="12" x2="16" y2="12"></line>
                                <line x1="8" y1="16" x2="16" y2="16"></line>
                            </svg>
                        </div>
                        <div className="mtl-landing-card-text">
                            <p className="mtl-landing-card-title">Load Management</p>
                            <p className="mtl-landing-card-desc">Manage dispatch plans and orders</p>
                        </div>
                        <svg className="mtl-landing-card-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>
                    </div>
                    <div className="mtl-landing-card" onClick={this.goTruckAutomation}>
                        <div className="mtl-landing-card-icon mtl-blue">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="1" y="7" width="14" height="10" rx="1"></rect>
                                <path d="M15 10h4l3 3v4h-7z"></path>
                                <circle cx="6" cy="18.5" r="1.7"></circle>
                                <circle cx="17.5" cy="18.5" r="1.7"></circle>
                            </svg>
                        </div>
                        <div className="mtl-landing-card-text">
                            <p className="mtl-landing-card-title">Truck Load Automation</p>
                            <p className="mtl-landing-card-desc">Scan and track vehicle loading</p>
                        </div>
                        <svg className="mtl-landing-card-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>
                    </div>
                </div>
            </div>
        );
    }
}
